import { render } from "./ModuleConfigurator.vue?vue&type=template&id=0b24c8d8"
import script from "./ModuleConfigurator.vue?vue&type=script&lang=js"
export * from "./ModuleConfigurator.vue?vue&type=script&lang=js"

import "./ModuleConfigurator.vue?vue&type=style&index=0&id=0b24c8d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__